export default "/images/fcede2d273a4b300935c40650d2bde1c.avif";